interface HeadProps {
  title: string;
  description?: string;
}

/**
 * Sets the page title and meta description in the document head.
 *
 * @param props.title - Page title
 * @param props.description - Meta description (defaults to "CLEOS application")
 * @returns Elements for the document head
 *
 * @example
 * <Head title="Dashboard" description="Overview of settlements" />
 */
export const Head = ({ title, description }: HeadProps) => {
  return (
    <>
      <title>{`${title} | CLEOS`}</title>
      <meta name="description" content={description ?? 'CLEOS application'} />
    </>
  );
};
